import React, { useState } from 'react'
import { addClientMachinery } from 'features/clientMachinery/clientMachinerySlice'
import { useDispatch } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import {
  Flex,
  H1WithBack,
  TabsContainer,
  Tabs,
  PageWrapper,
  ContentWrapper,
} from '../../styling/GlobalStyles'
import { MachineryCapabilitiesTab } from './MachineryCapabilitiesTab'
import { MachinerySpecificationTab } from './MachinerySpecificationTab'
import { AppDispatch } from 'store'
import { IMachinery } from 'types/machinery.interface'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

export const AddMachinery = () => {
  const [active, setActive] = useState('Specification')
  const [state, setState] = useState<IMachinery>({
    name: '',
    machineCategoryId: null,
    machineryModelId: null,
    ownership: null,
    costPerHour: null,
    hoursWorked: null,
    chassisNumber: null,
    licensePlate: null,
    fuelTankCapacity: null,
    status: null,
    machineCost: null,
    purchaseDate: null,
    maintenanceCosts: [{ year: 1000, q1: 1000, q2: 1000, q3: 1000, q4: 1000 }],
    yearOfManfacture: null,
    operations: [],
    machineCategory: null,
    machineryModel: null,
    usageType: null,
    vehicle: null,
    vehicleProvider: null
  })
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const handleSubmit = async () => {
    if (state.ownership == 1 && !state.machineCost) {
      toast.warning('Machine cost must be entered for selected ownership.')
      return
    }

    if (state.ownership == 2 && !state.costPerHour) {
      toast.warning('Machine cost must be entered for selected ownership.')
      return
    }

    if (!state.name || !state.machineCategory?.id || !state.machineryModel?.id) {
      toast.warning('All required fields must be filled.')
      return
    }

    const resp = await dispatch(addClientMachinery(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/machinery')
    }
  }

  const renderTabs = () => {
    if (active == 'Specification') {
      return (
        <MachinerySpecificationTab
          state={state}
          setState={setState}
          handleSubmit={handleSubmit}
          setActive={setActive}
          isAdding={true}
        />
      )
    } else if (active == 'Capabilities') {
      return (
        <MachineryCapabilitiesTab state={state} setState={setState} handleSubmit={handleSubmit} />
      )
    } else {
      return (
        <MachinerySpecificationTab
          state={state}
          setState={setState}
          handleSubmit={handleSubmit}
          setActive={setActive}
        />
      )
    }
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack title='Add Machinery' arrow />

          <TabsContainer>
            <Tabs active={active === 'Specification'} onClick={() => setActive('Specification')}>
              Basic Info
            </Tabs>
            <Tabs active={active === 'Capabilities'} onClick={() => setActive('Capabilities')}>
              Capabilities
            </Tabs>
          </TabsContainer>
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </>
  )
}
